$(document).ready(function() {
    $("a.yv-dropdown-item-link").each(function() {
        if ($(this).text().trim() === "See All") {
            $(this).css("font-weight", "bold");
        }
        if ($(this).text().trim() === "Sales & Clearance") {
            this.style.setProperty("color", "red", "important");
        }
    });
});
